import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import ScrollToTop from './components/scrolltotop';
import Businesspage from './mainpages/businesspage';
import Pricing from './mainpages/secondarypages/pricing';
import FullPageLoader from './components/FullPageLoader';
import Settingspage from './mainpages/secondarypages/settingspage';
import Userpage from './mainpages/secondarypages/useractivity';
import LogInBusiness from './mainpages/secondarypages/loginbusiness';
import Mainpage from './mainpages/mainpage';
import CategoriesPage from './mainpages/categoriesPage';
import SelectedCompany from './mainpages/selectedCompany';
import SearchedCompany from './mainpages/SearchedCompany';
import Aboutus from './mainpages/secondarypages/aboutus';
import Login from './mainpages/secondarypages/login';
import Signup from './mainpages/secondarypages/signup';
import Passrecovery from './mainpages/secondarypages/passwordRecovery';
import Privacy from './mainpages/secondarypages/privacy';
import Terms from './mainpages/secondarypages/terms';
import Faqs from './mainpages/secondarypages/faqs';
import SignUpBusiness from './mainpages/secondarypages/signupbusiness';
import Homepage from './mainpages/businesspages/homepage';
import Widgetpage from './mainpages/businesspages/widgetspage';
import Yourpage from './mainpages/businesspages/yourpage';
import Settingsbusiness from './mainpages/businesspages/settingsbusiness';
import BusinessWritten from './mainpages/admin/bwt';
import Reports from './mainpages/admin/reports';
import Agents from './mainpages/admin/agents';
import TestimonialAprov from './mainpages/admin/testimonialAprov';
import Businessclaim from './mainpages/admin/businessclaim';
import ClaimBusiness from './mainpages/secondarypages/claimbusiness';
import ReviewPage from './components/reviewflows/reviewPage';
import Intel from './mainpages/businesspages/intel';
import { useAuth } from './context/AuthContext';
import Analytics from './mainpages/businesspages/analytics';
import InvitedReviews from './mainpages/admin/invitedReviews';
import NotFoundPage from './mainpages/secondarypages/notfoundpage';
import Registry from './components/registry';
import BusinessFaqs from './mainpages/businesspages/businessFaqs';
import Refund from './mainpages/secondarypages/refund';
import AuthRedirectTracker from './components/authTracker';
import Recovery from './mainpages/secondarypages/passRecoveryField';
import BlogHome from './mainpages/blogs';
import BlogPosts from './mainpages/blogposts';
import { AgentTerminal } from './components/agentTerminal';
import BlogVerifiedReviews from './mainpages/blogs/blogVerifiedReviews';
import BlogTrustpilotAlternatives from './mainpages/blogs/pilotAlternatives';
import BlogStateOfReviews from './mainpages/blogs/blogResearch';
import SubmissionHistory from './mainpages/businesspages/submissionHistory';
import ReviewImportance from './mainpages/blogs/reviewImportance';

function App() {
  const { user, isBusiness, isAdmin, loading } = useAuth();
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage') || 'english');
  const [flagIcon, setFlagIcon] = useState('./assets/finalicon.svg');

  useEffect(() => {
    const icons = {
      german: '../src/assets/germany-svgrepo-com.svg',
      french: './assets/flag-for-france-svgrepo-com.svg',
      english: './assets/globe-web-browser-svgrepo-com (1).svg'
    };
    setFlagIcon(icons[selectedLanguage] || icons.english);
    localStorage.setItem('selectedLanguage', selectedLanguage);
  }, [selectedLanguage]);

  const handleLanguageChange = () => {
    const next = { german: 'french', french: 'english', english: 'german' };
    setSelectedLanguage(next[selectedLanguage]);
  };

  if (loading) return <FullPageLoader />;

  return (
    <BrowserRouter>
      {/* ⚡️ THE FIX: This wrapper ensures the footer is pinned and prevents CLS */}
      <div className="flex flex-col min-h-screen">
        
        <AuthRedirectTracker />
        <ScrollToTop />
        
        <Header
          session={user}
          isBusiness={isBusiness}
          isAdmin={isAdmin}
          selectedLanguage={selectedLanguage}
          handleLanguageChange={handleLanguageChange}
          flagIcon={flagIcon}
        />

        {/* ⚡️ THE FIX: flex-grow makes the content area expand to fill the gap */}
        <main className="flex-grow">
          <Routes>
            {/* UNIVERSAL ROUTES */}
            <Route path="/verify-feedback/guest/:token" element={<ReviewPage isGuest={true} />} />
            <Route path="/verify-feedback/authorized/:token" element={<ReviewPage isGuest={false} />} />
            <Route path="/categories/:categoryName" element={<CategoriesPage selectedLanguage={selectedLanguage} />} />
            <Route path="/company/:www" element={<SelectedCompany selectedLanguage={selectedLanguage} />} />
            <Route path="/business" element={<Businesspage selectedLanguage={selectedLanguage} />} />
            <Route path="/pricing" element={<Pricing selectedLanguage={selectedLanguage} />} />
            <Route path="/about-us" element={<Aboutus selectedLanguage={selectedLanguage} />} />
            <Route path="/faqs" element={<Faqs selectedLanguage={selectedLanguage} />} />
            <Route path="/terms" element={<Terms selectedLanguage={selectedLanguage} />} />
            <Route path="/Privacy" element={<Privacy selectedLanguage={selectedLanguage} />} />
            <Route path="/refund-policy" element={<Refund selectedLanguage={selectedLanguage} />} />
            <Route path="/registry" element={<Registry selectedLanguage={selectedLanguage} />} />
            <Route path="/users/:id" element={<Userpage selectedLanguage={selectedLanguage} />} />
            <Route path="/blogs" element={<BlogHome selectedLanguage={selectedLanguage} />} />
            <Route path="/blog/:slug" element={<BlogPosts />} /> 
            <Route path="/blogs/verified-reviews" element={<BlogVerifiedReviews />} /> 
            <Route path="/blogs/trustpilot-alternatives" element={<BlogTrustpilotAlternatives />} /> 
            <Route path="/blogs/why-verified-reviews-matter" element={<ReviewImportance />} />
            <Route path="/blogs/state-of-reviews" element={<BlogStateOfReviews />} /> 
            <Route path="/agent-terminal" element={<AgentTerminal />} /> 

            {user ? (
              isBusiness ? (
                /* BUSINESS ROUTES */
                <>
                  <Route path="/business/home" element={<Homepage selectedLanguage={selectedLanguage} />} />
                  <Route path="/" element={<Homepage selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/widget" element={<Widgetpage selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/your-page" element={<Yourpage selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/your-page/submission-history" element={<SubmissionHistory />} />
                  <Route path="/business/business-intel" element={<Intel selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/analytics" element={<Analytics selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/settings" element={<Settingsbusiness selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/pricing" element={<Pricing isBusiness={true} selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/faqs" element={<BusinessFaqs selectedLanguage={selectedLanguage} />} />
                  <Route path="/recovery" element={<Recovery selectedLanguage={selectedLanguage} />} />
                  <Route path="*" element={<Navigate to="/business/home" replace />} />
                </>
              ) : (
                /* CONSUMER ROUTES */
                <>
                  <Route path="/settings/*" element={<Settingspage selectedLanguage={selectedLanguage} />} />
                  <Route path="/pricing" element={<Pricing selectedLanguage={selectedLanguage} />} />
                  <Route path="/claim-business" element={<ClaimBusiness selectedLanguage={selectedLanguage} />} />
                  <Route path="/" element={<Mainpage selectedLanguage={selectedLanguage} />} />
                  <Route path="/about-us" element={<Aboutus selectedLanguage={selectedLanguage} />} />
                  <Route path="/business/signup" element={<SignUpBusiness selectedLanguage={selectedLanguage} />} />
                  <Route path="/recovery" element={<Recovery selectedLanguage={selectedLanguage} />} />

                  {isAdmin && (
                    <>
                      <Route path="/admin/reports" element={<Reports selectedLanguage={selectedLanguage} />} />
                      <Route path="/admin/business-approval" element={<Businessclaim selectedLanguage={selectedLanguage} />} />
                      <Route path="/admin/testimonial-approval" element={<TestimonialAprov selectedLanguage={selectedLanguage} />} />
                      <Route path="/admin/invited-reviews" element={<InvitedReviews selectedLanguage={selectedLanguage} />} />
                      <Route path="/admin/business-written-approval" element={<BusinessWritten selectedLanguage={selectedLanguage} />} />
                      <Route path="/admin/agents" element={<Agents selectedLanguage={selectedLanguage} />} />
                    </>
                  )}
                  <Route path="*" element={<NotFoundPage selectedLanguage={selectedLanguage} />} />
                </>
              )
            ) : (
              /* PUBLIC ROUTES */
              <>
                <Route path="/signup" element={<Signup selectedLanguage={selectedLanguage} />} />
                <Route path="/signin" element={<Login selectedLanguage={selectedLanguage} />} />
                <Route path="/business/signup" element={<SignUpBusiness selectedLanguage={selectedLanguage} />} />
                <Route path="/business/login" element={<Login selectedLanguage={selectedLanguage} />} />
                <Route path="/forgot-password" element={<Passrecovery selectedLanguage={selectedLanguage} />} />
                <Route path="/recovery" element={<Recovery selectedLanguage={selectedLanguage} />} />
                <Route path="/" element={<Mainpage selectedLanguage={selectedLanguage} />} />
                <Route path="*" element={<NotFoundPage selectedLanguage={selectedLanguage} />} />
              </>
            )}
          </Routes>
        </main>

        <Footer session={user} />
        
      </div>
    </BrowserRouter>
  );
}

export default App;